<template>
  <div class="row">
    <div style="background-color: #ffffcc" class="col-md-12 pt-3 mt-3 mb-5 border text-body">
      <p><font size="3" STYLE="font-size : 83%;">This web-application program was developed by Hidetaka Manabe. An 
        original program was formulated by Shinsuke Koyama. The analysis was 
        directed by <a href="http://www.ton.scphys.kyoto-u.ac.jp/~shino/english.html" target="_blank">Shigeru Shinomoto</a>.</font></p>

      <p><font size="3" style="font-size : 83%;">Here, N is the number of particles employed for the sequential Monte 
        Carlo algorithm, and γ is a hyperparameter that characterized the Cauchy distribution of the system equation. 
        In the original paper, N and γ are taken as 1000000 and 0.001, respectively.</font></p>
        
      <p><font size="3" style="font-size : 83%;">[Reference] <a href="https://journals.plos.org/ploscompbiol/article?id=10.1371/journal.pcbi.1008679" target="_blank"><br>
      Koyama S, Horie T, Shinomoto S (2021) Estimating the time-varying reproduction number of COVID-19 with a state-space method. 
      PLOS Computational Biology 17(1): e1008679. https://doi.org/10.1371/journal.pcbi.1008679 </a></font></p>
        
      <p id="access"><font size="3" STYLE="font-size : 83%;">Version 1.0: 2020/08/12. Version 2.0:2021/02/04.</font><font size="3"></font> </p>
        
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tail'
}
</script>

<style>
</style>